<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <p>
        Sign up for your Stay Seated account. You're just seconds away from
        getting food and drink right to your seat - never miss another minute of
        the action!
      </p>
      <p class="ion-padding-bottom">
        Sign up with...
      </p>
      <p>
        <ion-button
          v-if="canApple"
          expand="block"
          @click="handleSignUpWithApple()"
          ref="apple-sign-in"
          class="no-casing"
          style="--background: black"
        >
          <img src="./apple.svg" slot="start" />
          Sign up with Apple
        </ion-button>
      </p>
      <p>
        <ion-button
          expand="block"
          @click="handleSignUpWithGoogle()"
          class="no-casing"
          color="light"
        >
          Sign up with Google
        </ion-button>
      </p>
      <p>
        <ion-button
          expand="block"
          @click="handleSignUpWithFacebook()"
          class="no-casing"
          style="--background: #3b5998"
        >
          Sign up with Facebook
        </ion-button>
      </p>
      <p>
        <ion-button
          expand="block"
          @click="handleSignUpWithEmail()"
          class="no-casing"
        >
          Email and Password
        </ion-button>
      </p>
      <p class="ion-text-center tos">
        By using this app, you agree to the
        <a href="https://stayseatedinc.net/legal" target="_blank">
          terms of service </a
        >.
      </p>
      <section class="ion-padding ion-margin">
        <hr class="divider" />
      </section>
      <p class="ion-text-center">
        <ion-button
          size="small"
          fill="clear"
          color="dark"
          @click="handleHasAccount()"
        >
          I already have an account.
        </ion-button>
        <br />
        <ion-button
          size="small"
          fill="clear"
          color="danger"
          @click="handleSkipSignUp()"
          data-cy="skip-sign-up-button"
        >
          Skip For Now
        </ion-button>
      </p>
    </ion-content>
  </ion-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PlatformService from "@/services/Platform";
import ErrorAlert from "@/ErrorAlert";

export default {
  title: "Sign Up",

  methods: {
    ...mapActions("auth", [
      "signUpWithGoogle",
      "signUpWithFacebook",
      "signUpWithApple",
      "signUpSkip"
    ]),

    handleHasAccount() {
      this.$router.push({ name: "Sign In" }).catch(e => e);
    },

    handleSkipSignUp() {
      this.signUpSkip();
      this.$router.push("/").catch(e => e);
    },

    handleSignUpWithEmail() {
      this.$router.push({ name: "Sign Up With Email" }).catch(e => e);
    },

    async handleSignUpWithGoogle() {
      let loginResult = await this.signUpWithGoogle();
      this.handleAuthNextStep(loginResult);
    },

    async handleSignUpWithFacebook() {
      let loginResult = await this.signUpWithFacebook();
      this.handleAuthNextStep(loginResult);
    },

    async handleSignUpWithApple() {
      let loginResult = await this.signUpWithApple();
      this.handleAuthNextStep(loginResult);
    },

    handleAuthNextStep(loginResult) {
      if (loginResult === false) {
        ErrorAlert(this.authError.message);
      } else {
        this.$router.push("/").catch(e => e);
      }
    }
  },

  computed: {
    ...mapGetters("auth", ["authError"]),

    canApple() {
      return !PlatformService.isAndroid();
    }
  }
};
</script>

<style>
.tos {
  font-size: 0.8rem;
}
.no-casing {
  text-transform: none;
}
</style>
